const DATA_ELEMENT_ID = 'glitch-data';

const readInitialPayload = () => {
  const el = document.getElementById(DATA_ELEMENT_ID);
  if (!el || !el.textContent) {
    return {};
  }
  try {
    return JSON.parse(el.textContent);
  } catch (error) {
    console.error('Unable to parse initial app data', error);
    return {};
  }
};

export const createAppStore = () => {
  const payload = readInitialPayload();
  return {
    favourites: payload.favourites || [],
    set(key, value) {
      this[key] = value;
    },
  };
};

export const initAppStore = (Alpine) => {
  if (Alpine.store('app')) {
    return Alpine.store('app');
  }
  const store = createAppStore();
  Alpine.store('app', store);
  return store;
};
